import { render, staticRenderFns } from "./processAttributeSet.vue?vue&type=template&id=f74c7cb2&lang=pug"
import script from "./processAttributeSet.vue?vue&type=script&lang=js"
export * from "./processAttributeSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports